import React from "react";

const About = () => (
  <>
    <style>{`
      @keyframes slideInLeft {
        from {
          opacity: 0;
          transform: translateX(-50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.9);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }

      @keyframes fadeInDown {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .about-image {
        animation: slideInLeft 0.8s ease-out;
      }

      .about-content {
        animation: slideInRight 0.8s ease-out;
      }

      .about-tag {
        animation: fadeInDown 0.6s ease-out;
      }

      .about-title {
        animation: fadeInDown 0.6s ease-out 0.1s both;
      }

      .about-text {
        animation: fadeInDown 0.6s ease-out 0.2s both;
      }

      .about-list {
        animation: slideInRight 0.8s ease-out 0.3s both;
      }

      .list-item {
        animation: slideInRight 0.6s ease-out;
      }

      .list-item:nth-child(1) { animation-delay: 0.4s; }
      .list-item:nth-child(2) { animation-delay: 0.45s; }
      .list-item:nth-child(3) { animation-delay: 0.5s; }
      .list-item:nth-child(4) { animation-delay: 0.55s; }
      .list-item:nth-child(5) { animation-delay: 0.6s; }
      .list-item:nth-child(6) { animation-delay: 0.65s; }

      .about-badge {
        animation: scaleIn 0.8s ease-out 0.4s both;
      }

      .about-dot {
        animation: scaleIn 0.8s ease-out 0.5s both;
      }

      .list-item:hover {
        transform: translateX(10px);
        transition: transform 0.3s ease;
      }
    `}</style>

    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
        {/* Video */}
        <div className="relative about-image">
          <div className="rounded-3xl aspect-video flex items-center justify-center overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/K4GsdIFV5-c?si=mmQUFsomMkTDh7Lu&start=29"
              title="What is HelaDoc?"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
          {/* Decorative dot */}
          <div className="about-dot absolute top-8 -right-4 w-20 h-20 rounded-full bg-[#1A7A7A]/10 hover:bg-[#1A7A7A]/20 transition-colors duration-300" />
        </div>

        {/* Content */}
        <div className="about-content">
          <span className="about-tag inline-flex items-center gap-2 bg-slate-100 border border-slate-300 rounded-full px-4 py-2 text-xs font-semibold text-slate-700 mb-6">
            <span className="w-2 h-2 bg-slate-700 rounded-full" />
            What is HelaDoc?
          </span>
          <h2 className="about-title font-playfair text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">Your AI Telemedicine platform for fast, intelligent care</h2>
          <p className="about-text text-gray-600 mb-4 text-lg leading-relaxed">
            HelaDoc connects patients with doctors, pharmacies, labs, insurers, and diagnostic services in one seamless platform.
          </p>
          <ul className="about-list space-y-3 text-sm text-gray-600 mb-8">
            {[
              "Remote consultations via video/audio",
              "Online pharmacy & lab integration",
              "Instant insurance claim submission & tracking",
              "Medical imaging analysis",
              "AI-assisted diagnostics & psychiatric support",
              "Islandwide healthcenter network"
            ].map((item) => (
              <li key={item} className="list-item hover:text-[#1A7A7A] transition-colors duration-200 leading-relaxed">
                <span className="text-[#1A7A7A] font-bold text-lg">●</span> {item}
              </li>
            ))}
          </ul>
          <div className="border-t border-gray-100 pt-6 mt-6">
            <p className="font-playfair text-xl italic text-[#1A7A7A]">HelaDoc Team</p>
            <p className="text-xs text-gray-400 mt-1">AI-Driven Health & Wellness</p>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default About;
